import { ImportIcon } from '~components/icons'
import { TextButton, theme } from '~components/web-components'
import { format } from 'date-fns'
import { useParams } from 'react-router-dom'
import styled from 'styled-components'
import { useGetGeneralInfo } from '~hooks/queries/vessels/use-get-general-info'
import { useDateFormat } from '~hooks/use-date-format'
import { COLORS } from '~theme/colors'
import { exportToExcel } from '~utils/export-to-excel'
import TagManager from 'react-gtm-module'

interface Props {
  fileName: string
  tablesContainerRef: React.RefObject<HTMLDivElement>
  tableParser: (tableRef: React.RefObject<HTMLDivElement>) => string
}

export const StyledTextButton = styled(TextButton)`
  padding-right: 0;
  padding-left: ${theme.SPACINGS[1]};
  padding-top: ${theme.SPACINGS[1]};
  padding-bottom: 0;

  path {
    fill: ${COLORS.secondary.darkBlue};
  }
`

export function DownloadTablesButton({
  tablesContainerRef,
  tableParser,
  fileName,
}: Props) {
  const { vessel } = useParams()
  const { data: generalInfo } = useGetGeneralInfo({ vessel })
  const dateFormat = useDateFormat()

  return (
    <StyledTextButton
      startIcon={<ImportIcon width="24px" height="24px" />}
      onClick={() => {
        trackDownloadButtonClick(fileName)
        exportToExcel(
          tableParser(tablesContainerRef),
          `${generalInfo?.name || vessel}-${fileName}-${format(new Date(), dateFormat)}`,
        )
      }}
    />
  )
}

export const trackDownloadButtonClick = (fileName: string) => {
  const tagManagerArgs = {
    dataLayer: {
      event: 'internal_click',
      click_type: 'Document Download',
      click_subtype: fileName,
    },
  }
  TagManager.dataLayer(tagManagerArgs)
}
